// extracted by mini-css-extract-plugin
export var galleryItem = "Gallery-module--galleryItem--2277b";
export var galleryWrapper = "Gallery-module--galleryWrapper--f7929";
export var icon = "Gallery-module--icon--a72d3";
export var image = "Gallery-module--image--8d775";
export var imageRadius = "Gallery-module--imageRadius--a3fd4";
export var imageWrapper = "Gallery-module--imageWrapper--7468d";
export var info = "Gallery-module--info--1f01a";
export var textWrapper = "Gallery-module--textWrapper--1dc4c";
export var title = "Gallery-module--title--eb9bb";